import { useContext, useEffect, useState, useMemo } from "react";
import Select from "react-select";
import { useIncidents } from "../../../hooks/useIncidents";
import { getNameIncidentsPriority, translate } from "../../../utils/Common";
import ThemeContext from "../../../contexts/theme";
import { getReactSelectStyles } from "../../../utils/reactSelectThemeStyles";
import { TbFlag3 } from "react-icons/tb";
import ignoreAbort from '../../../utils/ignoreAbort';
import { SelectShell } from "@/components/ui/select-shell";

const PriorityIncidentList = ({
  register,
  errors,
  setValue,
  nameShow,
  idShow,
  readOnly,
  sizeInput,
}) => {
  const themeContext = useContext(ThemeContext);
  const theme = themeContext?.theme || "light";
  const selectStyles = useMemo(() => getReactSelectStyles(theme, { hasIcon: true }), [theme]);
  const { priorityIncidents, getPriorities } = useIncidents();
  const [prioritiesIncidents, setPrioritiesIncidents] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const abortController = new AbortController();

    const handlePriority = async () => {
      const response = await getPriorities(abortController.signal);
      setPrioritiesIncidents(response);
      setLoading(false);
    };

    if (!priorityIncidents) {
      handlePriority().catch(ignoreAbort);
    } else {
      setPrioritiesIncidents(priorityIncidents);
      setLoading(false);
    }

    return () => abortController.abort();
  }, [getPriorities, priorityIncidents]);

  const selectOptions = useMemo(() => {
    if (!prioritiesIncidents || !Array.isArray(prioritiesIncidents)) return [];
    return prioritiesIncidents.map((item) => ({
      value: item.id,
      label: getNameIncidentsPriority(item.id) || String(item.id),
      ...item,
    }));
  }, [prioritiesIncidents]);

  /* Valor inicial en edición (UpdateIncident pasa idShow y nameShow) */
  useEffect(() => {
    if (idShow != null && idShow !== "" && selectOptions.length > 0 && selectedOption == null) {
      const initial = selectOptions.find((opt) => opt.value === idShow);
      if (initial) setSelectedOption(initial);
    }
  }, [idShow, selectOptions, selectedOption]);

  const fieldName = "priorityIncident";

  return (
    <SelectShell icon={<TbFlag3 size={16} />} error={errors?.priorityIncident}>
          <Select
            value={selectedOption}
            options={selectOptions}
            isLoading={loading}
              classNamePrefix="react-select"
            placeholder={nameShow || translate("global.select")}
            name={fieldName}
            onChange={(e) => {
              setSelectedOption(e);
              if (setValue) {
                setValue(fieldName, e ? e.value : "", { shouldValidate: true });
              }
            }}
            isClearable
            isSearchable
            filterOption={(option, search) =>
              (option.label || "")
                .toLowerCase()
                .includes((search || "").toLowerCase())
            }
            noOptionsMessage={() => translate("global.noResults")}
            styles={selectStyles}
            isDisabled={readOnly}
          />
        <input
          type="hidden"
          name={fieldName}
          value={selectedOption?.value ?? ""}
          ref={
            register &&
            register({
              validate: (value) =>
                (value !== "" &&
                  value !== translate("global.select") &&
                  value !== translate("global.noResults")) ||
                translate("global.chooseValidPriority"),
            })
          }
        />
    </SelectShell>
  );
};

export default PriorityIncidentList;
